/**
 * @generated SignedSource<<ff302f5152373da4c308a69e85d232a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitScreenMain_user$data = {
  readonly account: {
    readonly custom_select_types: ReadonlyArray<{
      readonly id: number;
      readonly name: string;
    }>;
    readonly id: number;
  };
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"SplitScreenRow_user">;
  readonly " $fragmentType": "SplitScreenMain_user";
};
export type SplitScreenMain_user$key = {
  readonly " $data"?: SplitScreenMain_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitScreenMain_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitScreenMain_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SplitScreenRow_user"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "custom_select_types",
          "kind": "LinkedField",
          "name": "custom_select_types",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "8724d7db7e0d26d6976777edb716ff68";

export default node;
